import styled from "styled-components";

export const Container = styled.div`
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;